import React, { FC } from 'react'
import { AuthUser } from '../../typings/auth.def'
import { setApolloAuth, unsetApolloAuth } from '../../apollo/apollo-client'
import { AuthProviderContext } from './context/AuthContext'

type AuthProviderProps = {
  data?: AuthUser | null
}

const AuthProvider: FC<AuthProviderProps> = ({ children, data }) => {
  const [authUser, setUser] = React.useState<AuthUser | undefined | null>(data)
  const setAuthUser = (user: AuthUser) => {
    setApolloAuth(user)
    setUser(user)
  }

  const unsetAuthUser = () => {
    unsetApolloAuth()
    setUser(null)
  }

  return (
    <AuthProviderContext.Provider
      value={{
        authUser,
        setAuthUser,
        unsetAuthUser,
        userId: authUser?.id
      }}
    >
      {children}
    </AuthProviderContext.Provider>
  )
}

AuthProvider.displayName = 'AuthProvider'

export default AuthProvider
